'use client'

import { Control, Controller } from 'react-hook-form'
import { Switch } from 'app/components/atoms'
import { useTranslation } from 'app/i18n/client'

interface FormUndatedToggleProps {
  control: Control<any>
  name?: string
  id?: string
  onToggle?: (checked: boolean) => void
}

const FormUndatedToggle: React.FunctionComponent<FormUndatedToggleProps> = ({
  control,
  name = 'undatedSearch',
  id = 'undated-search-toggle',
  onToggle,
}) => {
  const { t } = useTranslation()
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Switch
          id={id}
          label={t('Date undecided')}
          // Desktop stacks label above the switch so longer locale
          // strings don't squeeze the row. Mobile instances live in
          // lg:hidden cells, so the lg: variants never reach them.
          className="lg:flex-col"
          checked={!!field.value}
          onChange={(checked) => {
            field.onChange(checked)
            onToggle?.(checked)
          }}
        />
      )}
    />
  )
}

export default FormUndatedToggle
